<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';
import { currency } from '@elements/number-formatter';
import { BILLING_DOCUMENT_TYPES } from '../../constants/constants';

const props = defineProps({
  invoice: {
    type: Object,
    required: true,
  },
});

const multiplier = computed(() => (props.invoice.type === BILLING_DOCUMENT_TYPES.CREDIT_NOTE
  ? -1
  : 1));
// eslint-disable-next-line no-mixed-operators
const invoiceAmount = computed(() => currency(props.invoice.amount / 100 * multiplier.value) ?? null);
const period = computed(() => new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: 'long' }).format(props.invoice.created_date));
const status = computed(() => props.invoice.status?.toLowerCase());
</script>

<template>
  <div class="billing-document-summary-card card">
    <div class="card--title">
      <span>{{ trans('gestion.invoice') }} #{{ invoice.invoice_number }}</span>
      <span class="status-label" :class="`status-label--${status}`">
        {{ trans(`gestion.invoice.status.${invoice.type}.${status}`) }}
      </span>
    </div>
    <div class="card--body">
      <span>{{ invoiceAmount }} • {{ period }}<br></span>
      <span>{{ invoice.customer_email }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.card {
  display: flex;
  align-items: start;
  padding: rem(16);
  margin-top: rem(24);
  margin-bottom: rem(48);

  &--title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex: 1 auto;

    &:first-child {
      font-weight: bold;
    }
  }
}
</style>
